module.exports = __webpack_public_path__ + "static/media/Cookingtale.6c8c5d94.png";